import React, { useState } from 'react';
import { Card, CardContent, Typography, Grid, TextField, Button, FormControl,Box, CircularProgress } from '@mui/material';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useFormikContext } from 'formik';
import { DatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import {  IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useAuth } from '../../../AuthProvider';

const baseUrl=process.env.REACT_APP_API_BASE_URL
export default function BranchTransfer() {
  const [loading, setLoading] = useState(false);
  // const { values, setFieldValue } = useFormikContext();
  const navigate = useNavigate();
  const {oId}=useAuth();

  const handleYearChange = (selectedYear) => {
    if (selectedYear) {
      const year = selectedYear.getFullYear(); // Extract the selected year
      const yearRange = `${year}-${year + 1}`; // Create the academic year range
      // setFieldValue('academicYear', yearRange); // Update Formik's value
    }
  };

  // Validation schema with Yup
  const validationSchema = Yup.object({
    admissionId: Yup.string()
      .matches(/^\d+$/, "Admission number must be numeric")
      .required("Admission number is required"),
      surName: Yup.string().required("surname is required"),
    firstName: Yup.string().required("First name is required"),
    lastName: Yup.string().required("Last name is required"),
    fathersMailId: Yup.string().email("Email is invalid").required("Email address is required"),
    primaryContact: Yup.string().matches(/^\d{10}$/, "Phone number must be 10 digits").required("Phone number is required"),
    currentSchool: Yup.string().required("Current School Name is required"),
    
    reasonForTransfer: Yup.string().required("Reason for transfer is required"),
    additionalComments: Yup.string().required("Additional comments are required"),
  });
 

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        minHeight: '100vh',
        paddingTop: '50px',
      }}
    >
      <Card
        style={{
          marginRight: "20px",
          marginLeft:'20px',
          marginTop:'10px',
          padding: "20px",
          backgroundColor: "#ffffff",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          borderRadius: "8px",
         
          width: "100%",
        }}
      >
        <CardContent>
          {/* <Typography
            variant="h2"
            style={{
              fontWeight: "bold",
              marginBottom: "10px",
              textAlign: "left",
            }}
          >
            
          </Typography> */}

<Box display="flex" alignItems="center" sx={{marginBottom:2}}>
                              <IconButton onClick={() => navigate(-1)} sx={{ color: '#2e2a54' }}>
                                <KeyboardBackspaceIcon fontSize="medium" />
                              </IconButton>
                              <Typography variant="h4" component="h3" sx={{fontWeight:'bold' }}>
                              Branch Transfer Application Form
                              </Typography>
                            </Box>

          
          {/* Formik Form */}
          <Formik
             initialValues={{
              surName: "",
              firstName: "",
              lastName: "",
              fathersMailId: "",
              primaryContact: "",
              currentSchool: "",
              reasonForTransfer: "",
              additionalComments: "",
              document: null, // Change to null for a file
            }}
            validationSchema={validationSchema}
            onSubmit={async (values, { setSubmitting }) => {
              setLoading(true);
            
              const formData = new FormData();
              Object.keys(values).forEach((key) => {
                formData.append(key, values[key]);
              });
            
              try {
                const response = await fetch(`${baseUrl}/api/studentTransfer/save/admit/${values.admissionId}`, {
                  method: "POST",
                  body: formData,
                });
            
                const data = await response.json();
            
                if (response.ok) {
                  console.log("Success:", data);
                  toast.success("Form Submitted Successfully!", { autoClose: 2000 });
                  navigate("/StudentTransferList")
                } else {
                  console.error("Error:", data);
                  const errorMessage = data?.message || "Error submitting the form. Please try again.";
                  toast.error(errorMessage, { autoClose: 2000 });  // Display the actual error message
                }
              } catch (error) {
                console.error("Error:", error);
                toast.error("An unexpected error occurred. Please try again.", { autoClose: 2000 });
              } finally {
                setLoading(false);
                setSubmitting(false);
              }
            }}
            
            
          >
            {({ handleChange, handleBlur, values, errors, touched,setFieldTouched,setFieldValue, setFieldError ,setValues }) => (
              <Form>
             {/* Admission Number */}
<Grid container spacing={2} alignItems="center">
  {/* Admission Number Field */}
  <Grid item xs={3}>
    <Typography
      variant="h6"
      style={{
        fontWeight: 'bold',
        marginBottom: '10px',
        textAlign: 'left',
      }}
    >
      Admission Number
    </Typography>
    <FormControl fullWidth >
  <Field
    as={TextField}
    label="Admission Number"
    variant="outlined"
    fullWidth
    size="medium" // Decreases the input field size
    name="admissionId"
    value={values.admissionId}
    onChange={handleChange}
    onBlur={handleBlur}
    error={touched.admissionId && Boolean(errors.admissionId)}
    helperText={touched.admissionId && errors.admissionId}
    placeholder="Enter your admission number"
    id="admission-number"
  />
</FormControl>

  </Grid>

  {/* Get Button */}
  <Grid item xs={1}>
    <Button
      variant="outlined"
      fullWidth
      style={{
        height: '53px',
        width:'8rem',
        marginTop: '25px',
        backgroundColor: '#f0f0f0',
        color: '#333',
        border: '1px solid #ccc',
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
        fontWeight: 'bold',
      }}
      onClick={async () => {
        if (!values.admissionId) {
          setFieldTouched("admissionId", true);
          setFieldError("admissionId", "Admission number is required");
          return;
        }
      
        try {
          const response = await fetch(
            `${baseUrl}/api/admission/getAllStudentsDetails/${values.admissionId}/${oId}`
          );
      
          if (response.ok) {
            const data = await response.json();
            console.log("Student data:", data);
      
            setValues({
              ...values,
              surName: data.surName || "",
              firstName: data.firstName || "",
              lastName: data.lastName || "",
              fathersMailId: data.fathersMailId || "",
              primaryContact: data.primaryContact || "",
              currentSchool: data.currentSchool || "",
              fathersFirstName:data.fathersFirstName || "",
              fathersLastName:data.fathersLastName || "",
              romanNumberClass:data.romanNumberClass || "",
              sections:data.sections || ""

            });
      
            // Show success toast
            toast.success("Student data fetched successfully!", {
              position: "top-right",
              autoClose: 2000, // Auto-close after 2 seconds
            });
          } else {
            console.error("Failed to fetch data");
            toast.error("No data found for the given admission number.", {
              position: "top-right",
              autoClose: 2000,
            });
          }
        } catch (error) {
          console.error("Error:", error);
          toast.error("Error fetching data. Please try again.", {
            position: "top-right",
            autoClose: 2000,
          });
        }
      }
    }
    >
      Get
    </Button>
  </Grid>
</Grid>


                {/* Full Name */}
                <Typography
                  variant="h6"
                  style={{
                    fontWeight: 'bold',
                    marginBottom: '10px',
                    textAlign: 'left',
                  }}
                >
                  Full Name
                </Typography>
                <Grid container spacing={2}>


                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth style={{ marginBottom: '20px' }}>
                      <Field
                        as={TextField}
                        label="SurName"
                        variant="outlined"
                        fullWidth
                        name="surName"
                        value={values.surName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.surName && Boolean(errors.surName)}
                        helperText={touched.surName && errors.surName}
                        placeholder="Enter your Surname"
                      />
                       
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth style={{ marginBottom: '20px' }}>
                      <Field
                        as={TextField}
                        label="First Name"
                        variant="outlined"
                        fullWidth
                        name="firstName"
                        value={values.firstName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.firstName && Boolean(errors.firstName)}
                        helperText={touched.firstName && errors.firstName}
                        placeholder="Enter your first name"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth style={{ marginBottom: '20px' }}>
                      <Field
                        as={TextField}
                        label="Last Name"
                        variant="outlined"
                        fullWidth
                        name="lastName"
                        value={values.lastName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.lastName && Boolean(errors.lastName)}
                        helperText={touched.lastName && errors.lastName}
                        placeholder="Enter your last name"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
  <FormControl fullWidth style={{ marginBottom: "20px" }}>
    <Field
      as={TextField}
      label="Father Name"
      variant="outlined"
      fullWidth
      name="fathersFirstName"
      value={`${values.fathersFirstName || ""} ${values.fathersLastName || ""}`} // Combine First and Last Name
      // onChange={handleChange}
      // onBlur={handleBlur}
      // error={touched.fathersLastName && Boolean(errors.fathersLastName)}
      // helperText={touched.fathersLastName && errors.fathersLastName}
      placeholder="Enter Father's Name"
      // disabled // Make it non-editable
      // InputProps={{
      //   style: { backgroundColor: "#f0f0f0", color: "#6c757d" }, // Gray background to indicate non-editable
      // }}
    />
  </FormControl>
</Grid>

                </Grid>

                {/* Email and Phone Number */}
                <Typography
                  variant="h6"
                  style={{
                    fontWeight: 'bold',
                    marginBottom: '10px',
                    textAlign: 'left',
                  }}
                >
                  Contact Information
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth style={{ marginBottom: '20px' }}>
                      <Field
                        as={TextField}
                        label="Email Address"
                        variant="outlined"
                        fullWidth
                        name="fathersMailId"
                        value={values.fathersMailId}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.fathersMailId && Boolean(errors.fathersMailId)}
                        helperText={touched.fathersMailId && errors.fathersMailId}
                        placeholder="Enter your email address"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth style={{ marginBottom: '20px' }}>
                      <Field
                        as={TextField}
                        label="Phone Number"
                        variant="outlined"
                        fullWidth
                        name="primaryContact"
                        value={values.primaryContact}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.primaryContact && Boolean(errors.primaryContact)}
                        helperText={touched.primaryContact && errors.primaryContact}
                        placeholder="Enter your phone number"
                      />
                    </FormControl>
                  </Grid>
                </Grid>

                {/* Current School */}
                <Typography
                  variant="h6"
                  style={{
                    fontWeight: 'bold',
                    marginBottom: '10px',
                    textAlign: 'left',
                  }}
                >
                  Current School Information
                </Typography>
                <Grid container spacing={2}>
                  
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth style={{ marginBottom: '20px' }}>
                      <Field
                        as={TextField}
                        label="Present Class"
                        variant="outlined"
                        fullWidth
                        name="romanNumberClass"
                        value={`Class-${values.romanNumberClass || ""}`}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.romanNumberClass && Boolean(errors.romanNumberClass)}
                        helperText={touched.romanNumberClass && errors.romanNumberClass}
                        placeholder="Enter the class"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth style={{ marginBottom: '20px' }}>
                      <Field
                        as={TextField}
                        label="Current Section"
                        variant="outlined"
                        fullWidth
                        name="sections"
                        value={values.sections}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.sections && Boolean(errors.sections)}
                        helperText={touched.sections && errors.sections}
                        placeholder="Enter the Section"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth style={{ marginBottom: '20px' }}>
                      <Field
                        as={TextField}
                        label="Current School Name"
                        variant="outlined"
                        fullWidth
                        name="currentSchool"
                        value={values.currentSchool}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.currentSchool && Boolean(errors.currentSchool)}
                        helperText={touched.currentSchool && errors.currentSchool}
                        placeholder="Enter the school name"
                      />
                    </FormControl>
                  </Grid>
                </Grid>

                {/* City, State, PinCode */}
             

                {/* Reason for Transfer */}
                <Typography
                  variant="h6"
                  style={{
                    fontWeight: 'bold',
                    marginBottom: '10px',
                    textAlign: 'left',
                  }}
                >
                  Reason for Transfer
                </Typography>
                <FormControl fullWidth style={{ marginBottom: '20px' }}>
                  <Field
                    as={TextField}
                   
                    variant="outlined"
                    fullWidth
                    name="reasonForTransfer"
                    value={values.reasonForTransfer}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.reasonForTransfer && Boolean(errors.reasonForTransfer)}
                    helperText={touched.reasonForTransfer && errors.reasonForTransfer}
                    placeholder="Enter your reason for transfer"
                    multiline
                    rows={4}
                  />
                </FormControl>

                {/* Additional Comments */}
                <Typography
                  variant="h6"
                  style={{
                    fontWeight: 'bold',
                    marginBottom: '10px',
                    textAlign: 'left',
                  }}
                >
                  Additional Comments
                </Typography>
                <FormControl fullWidth style={{ marginBottom: '20px' }}>
                  <Field
                    as={TextField}
                    
                    variant="outlined"
                    fullWidth
                    name="additionalComments"
                    value={values.additionalComments}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.additionalComments && Boolean(errors.additionalComments)}
                    helperText={touched.additionalComments && errors.additionalComments}
                    placeholder="Enter any additional comments"
                    multiline
                    rows={4}
                  />
                </FormControl>

                

                {/* Upload Documents */}
                <Typography
        variant="h6"
        style={{
          fontWeight: "bold",
          marginBottom: "10px",
          textAlign: "left",
        }}
      >
        Upload Documents
      </Typography>
      <FormControl fullWidth style={{ marginBottom: "20px" }}>
        <Field name="document">
          {({ form }) => (
            <TextField
              variant="outlined"
              fullWidth
              type="file"
              inputProps={{ accept: ".pdf,.doc,.docx,.jpg,.png" }}
              onChange={(event) => {
                const file = event.target.files[0];
                form.setFieldValue("document", file);
                console.log("File selected:", file);
              }}
            />
          )}
        </Field>
      </FormControl>


                {/* Submit Button */}
                <div style={{ marginTop: '20px', textAlign: 'right' }}>
  <Button
    variant="contained" // Change the color here (e.g., 'secondary' for a different color)
    type="submit"
    disabled={loading}
    
    style={{
      padding: '10px 20px',
      fontSize: '13px',
      backgroundColor:'#3C3972',
      color:'#fff'
    }}
  >
    {loading ? (
      <CircularProgress size={24} color="inherit" />
    ) : (
      'Submit'
    )}
  </Button>
</div>
              </Form>
            )}
          </Formik>
          <ToastContainer />
        </CardContent>
      </Card>
    </div>
  );
}